import { pageBgColor } from "@/utils/theme";
import { HelmetDexteel } from "@dexteel/mesf-core";
import { Box, Typography } from "@mui/material";
import { UtilityTabs } from "../shared/components/UtilityTabs";
import { useUtilityKind } from "../shared/hooks/useUtilityKind";
import { UTILITY_KIND } from "../shared/models/Utility";
import { GasBills } from "./gas/components/GasBills";
import { WaterBills } from "./water/components/WaterBills";

const BILLING_UTILITIES = [UTILITY_KIND.WATER, UTILITY_KIND.GAS];

export const UtilityManagementPage = () => {
	const [utility, setUtility] = useUtilityKind(BILLING_UTILITIES);

	return (
		<>
			<HelmetDexteel title="Billing" />
			<Box
				sx={{
					bgcolor: pageBgColor,
					boxSizing: "border-box",
					display: "flex",
					flexDirection: "column",
					height: { lg: "calc(100vh - 100px)" },
					minHeight: { lg: "calc(100vh - 100px)" },
					p: { xs: 1, md: 2 },
				}}
			>
				<Typography
					component="h1"
					sx={{
						fontSize: "1.5rem",
						fontWeight: 600,
						lineHeight: 1.25,
						mb: 1,
					}}
				>
					Billing
				</Typography>
				<UtilityTabs
					utility={utility}
					available={BILLING_UTILITIES}
					onUtilityChange={setUtility}
				/>
				{utility === UTILITY_KIND.GAS ? <GasBills /> : <WaterBills />}
			</Box>
		</>
	);
};
